import React from 'react'

import { styled } from 'styled-components'
import { FilesPublicLinksErrorTypes } from 'features/public-link-files/model/slice/publicLinkFilesSlice'
import { AppLogo } from 'shared/components/AppLogo'

interface ErrorComponentProps {
  errorType: FilesPublicLinksErrorTypes;
}

const ERROR_TEXTS = {
  [FilesPublicLinksErrorTypes.NOT_EXIST]: 'File not found or shared link expired',
  [FilesPublicLinksErrorTypes.EMPTY_FOLDER]: 'Folder is empty',
  [FilesPublicLinksErrorTypes.NO_ACCESS]: 'No access',
  [FilesPublicLinksErrorTypes.SOMETHING_WENT_WRONG]: 'Something went wrong',
}

export const ErrorComponent: React.FC<ErrorComponentProps> = ({
  errorType
}) => {
  return (
    <ErrorContainer>
      <AppLogo 
        width={120}
        alt="Logo"
      />

      <ErrorTitle>
        {ERROR_TEXTS[errorType]}
      </ErrorTitle>

    </ErrorContainer>
  )
}

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  text-align: center;
  background-color: #f8f9fa;
`



const ErrorTitle = styled.h1`
  font-size: 24px;
  color: #6c757d;
  margin-bottom: 16px;
`
